
@if (businessUnits && businessUnits.length > 0 ) {
  <mat-form-field appearance="outline" class="flex-1">
    <mat-label translate="">Business unit</mat-label>
    <mat-select [formControl]="control()">
      <mat-option [value]="null"><span translate="">None</span></mat-option>
      @for (businessUnit of businessUnits; track businessUnit) {
        <mat-option [value]="businessUnit">{{ businessUnit.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}
